/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-10T12:05:16.697
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancePayApply,
	listFinancePayApplyInit,
	listFinancePayApplyByAuthorizations,
	deleteFinancePayApply,
    withdraw,
	
} from '@api/storagemanage/FinancePayApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancePayApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePayApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancePayApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePayApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancePayApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePayApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancePayApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancePayApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
        
        withdraw({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				withdraw({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
